import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Page from '../../components/Page';
import SettingsIcon from '@mui/icons-material/Settings';

import Users from './users';
// import Script from './script';
// import Subs from './payment';
//import Company from './company';

export default () => {
	return (
		<Page title={'Settings'} icon={<SettingsIcon sx={{ mr: 0.5 }} size="medium" />}>
			<Page.Wrap>
				<Switch>
					{/* <Route path="/settings/company" component={Company} /> */}
					<Route path="/settings" exact component={Users} />
					<Route path="/settings/token">
						<Redirect to="/developers/token" />
					</Route>
					<Route path="/settings/subscription">
						<Redirect to="/subscription" />
					</Route>
					<Redirect to="/settings" />
				</Switch>
				{/* <div className={'wa-float both right'}>
					<div className={'wa-popup'}>
						<button className="close" id="close-chat">
							<img className="img" alt="" src="/close2.svg"></img>
						</button>
						<div className="content-whatsapp -top">
							<p>{'I have question about payment.'}</p>
						</div>
						<div className="content-whatsapp -bottom"></div>
					</div>
					<a
						className={'blantershow-chat small'}
						href={`https://api.whatsapp.com/send?phone=908503464798&text=I have question about payment.`}
						target="_blank"
						without
						rel="noopener noreferrer"
					>
						<svg width="20" viewBox="0 0 24 24">
							<path fill="#eceff1" d="M20.5 3.4A12.1 12.1 0 0012 0 12 12 0 001.7 17.8L0 24l6.3-1.7c2.8 1.5 5 1.4 5.8 1.5a12 12 0 008.4-20.3z" />
							<path
								fill="#4caf50"
								d="M12 21.8c-3.1 0-5.2-1.6-5.4-1.6l-3.7 1 1-3.7-.3-.4A9.9 9.9 0 012.1 12a10 10 0 0117-7 9.9 9.9 0 01-7 16.9z"
							/>
							<path
								fill="#fafafa"
								d="M17.5 14.3c-.3 0-1.8-.8-2-.9-.7-.2-.5 0-1.7 1.3-.1.2-.3.2-.6.1s-1.3-.5-2.4-1.5a9 9 0 01-1.7-2c-.3-.6.4-.6 1-1.7l-.1-.5-1-2.2c-.2-.6-.4-.5-.6-.5-.6 0-1 0-1.4.3-1.6 1.8-1.2 3.6.2 5.6 2.7 3.5 4.2 4.2 6.8 5 .7.3 1.4.3 1.9.2.6 0 1.7-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.3-.6-.4z"
							/>
						</svg>
						{'I have question about payment.'}
					</a>
				</div>
			 */}
			</Page.Wrap>
		</Page>
	);
};
